<template>
  <div>
    <v-row justify-md="center">
      <v-col sm="10" md="7"><h1>Your Games</h1></v-col>

      <div class="container">
        <v-row md="10">
          <div  v-if="games.length==0">
            <v-alert
              type="info"
            
              border="left"
              dense
              text
            >You don't have any games yet.</v-alert>
          </div>

          <v-col sm="3" v-for="game in games" :key="game.id">
            <v-card class="ma-5 game-card" width="400" elevation="5">
              <div class='ribbon-wrapper' v-if="!(game.branch == 'default')">
                <div class='ribbon'>{{game.branch}}</div>
              </div>
              <v-img class="game-image" :src="game.project | image" height="400">
              <v-card-title>
                <span class="headline">{{game.project | productName}}</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-subtitle>

              </v-card-subtitle>

              <v-card-text>
                <v-simple-table dark>
                  <tbody>
                    <tr>
                      <th>Platform</th>
                      <td>{{game.platform | platformToAccountName}}</td>
                    </tr>
                    <tr>
                      <th>Last Played</th>
                      <td>{{game.last_login.time | formatTime}}</td>
                    </tr>
                    <tr>
                      <th>Website</th>
                      <td><a :href="game.project | website" target="_blank">{{game.project | website}}</a></td>
                    </tr>
                    <tr v-if="game.project === 'shoebill' && referralActive">
                      <td colspan="2">
                        <router-link  to="/second-extinction/referral">
                        Referral Program
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-card-actions style="position:absolute;bottom:0px;">
                <img height="30" :alt="game.project | companyName" :src="companyLogo(game.project)" />
              </v-card-actions>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<style scoped>

</style>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "../store";

import { account } from "../store/modules/account";

if (!store.state.account) store.registerModule("account", account);

const { mapState } = createNamespacedHelpers("account");

const productInfo = {
  thp: {
    name: "theHunter™ Call of the Wild",
    company: "Expansive Worlds",
    image: "https://acp-portal-assets.avalanchestudios.com/cover_art/thp_cover_art.jpg",
    web: "https://callofthewild.thehunter.com",
  },
  cataclysm: {
    name: "Generation Zero®",
    company: "Systemic Reaction",
    image: "https://acp-portal-assets.avalanchestudios.com/cover_art/gz_cover_art.jpg",
    web: "https://generationzero.com"
  },
  shoebill: {
    name: "Second Extinction",
    company: "Systemic Reaction",
    image: "https://acp-portal-assets.avalanchestudios.com/cover_art/shoebill_cover_art.png",
    web: "https://secondextinctiongame.com"
  },
  tortoise: {
    name: "Call of the Wild: The Angler™",
    company: "Expansive Worlds",
    image: "https://acp-portal-assets.avalanchestudios.com/cover_art/the_angler.png/cover_art_the_angler.png",
    web: ""
  },
  jackdaw: {
    name: "Ravenbound",
    company: "Systemic Reaction",
    image: "https://acp-portal-assets.avalanchestudios.com/Ravenbound/RavenboundApexPortalArt.png",
    web: ""
  },
};

const companyToLogo = {
  "Expansive Worlds": {
    light:
      "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Expansive_Worlds_Hori_RGB_Yellow.png",
    dark:
      "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Expansive_Worlds_Hori_RGB_Yellow.png",
  },
  "Systemic Reaction": {
    light:
      "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Systemic_Reaction_Hori_RGB_Cyan.png",
    dark:
      "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Systemic_Reaction_Hori_RGB_Cyan.png",
  },
};

const projectToProductNameFilter = function (value) {
  if (!productInfo[value]) return value;
  return productInfo[value].name;
};

const projectToImageFilter = function (value) {
  if (!productInfo[value]) return value;
  return productInfo[value].image;
};

const projectToCompanyNamefilter = function (value) {
  if (!productInfo[value]) return value;
  return productInfo[value].company;
};

const projectToWebsite = function (value) {
  if (!productInfo[value]) return value;
  return productInfo[value].web;
};

const platformToAccountName = function(value) {
  switch(value) {
    case "psn":
      return "PlayStation™ Network";
    case "xblive":
      return "Xbox Live";
    case "steam":
      return "Steam Account";
    case "thc":
      return "theHunter Classic Account";
    case "epic":
      return "Epic Games Account";
  }
  return value;
}

export default {
  name: "Games",
  filters: {
    productName: projectToProductNameFilter,
    companyName: projectToCompanyNamefilter,
    website: projectToWebsite,
    image: projectToImageFilter,
    platformToAccountName: platformToAccountName,
  },
  data() {
    return {
      referralActive: false
    }
  },
  computed: {
    ...mapState(["games"])
  },
  methods: {
    fetchData() {
      this.$store.dispatch("account/getGames");
    },
    isReferralActive() {
      const today = new Date();
      const dDay = new Date("12/31/22");
      this.referralActive = today.getTime() >= dDay.getTime();
    },
    companyLogo(value) {
      if (!productInfo[value]) return value;
      if (this.$vuetify.theme.dark) {
        return companyToLogo[productInfo[value].company].dark;
      }
      return companyToLogo[productInfo[value].company].light;
    },
  },
  created() {
    this.fetchData();
    this.isReferralActive();
  },
};
</script>